module.exports = __webpack_public_path__ + "img/ZhomebieICON.1c17fb29.png";